export default "__VITE_ASSET__B4H5ijBY__"